import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/logo.png';
import _imports_1 from '../assets/icon-phone.png';
import _imports_2 from '../assets/icon-msg.png';
import _imports_3 from '../assets/icon-wechat.png';
const _withScopeId = n => (_pushScopeId("data-v-0eb6a6f6"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "logo"
}, [/*#__PURE__*/_createElementVNode("img", {
  alt: "logo",
  src: _imports_0
})], -1));
const _hoisted_2 = {
  class: "login-content"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "login-title"
}, "短信登录", -1));
const _hoisted_4 = {
  class: "login-from"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "icon-phone"
}, null, -1));
const _hoisted_6 = {
  class: "input-code"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "icon-code"
}, null, -1));
const _hoisted_8 = {
  class: "divider"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "line"
}, null, -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text"
}, "第三方账号登录", -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "line"
}, null, -1));
const _hoisted_12 = [_hoisted_9, _hoisted_10, _hoisted_11];
import { computed, ref, getCurrentInstance } from 'vue';
import { useRouter } from 'vue-router';
import { sendSms, signInByMobile } from '@/request/api';
const __default__ = {
  name: 'login'
};
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    isPc: {
      type: Boolean
    }
  },
  setup(__props) {
    const router = useRouter();
    const instance = getCurrentInstance();
    const mobile = ref('');
    const code = ref('');
    const timeNum = ref(60);
    const Time = ref(0);
    // interface Props {
    //     isPC: boolean;
    //   }
    const codeDisable = computed(() => {
      return /^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(mobile.value) && timeNum.value == 60;
    });
    const loginDisable = computed(() => {
      return /^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(mobile.value) && code.value;
    });
    const getCode = async () => {
      if (!codeDisable.value) {
        return;
      }
      let data = {
        mobile: mobile.value,
        code: 'subo',
        scene: 'loginAndRegister'
      };
      await sendSms(data);
      timeNum.value--;
      if (Time.value) {
        clearInterval(Time.value);
        Time.value = 0;
      }
      Time.value = setInterval(() => {
        if (timeNum.value == 0) {
          clearInterval(Time.value);
          Time.value = 0;
          timeNum.value = 60;
        } else {
          timeNum.value--;
        }
      }, 1000);
    };
    const goInit = async () => {
      if (!loginDisable.value) {
        instance?.proxy?.$Bus.emit("showToast", true);
        setTimeout(() => {
          instance?.proxy?.$Bus.emit("showToast", false);
        }, 2000);
        return;
      }
      instance?.proxy?.$Bus.emit("showLoginLoading", true);
      let data = {
        mobile: mobile.value,
        verificationCode: code.value,
        code: 'subo',
        scene: 'loginAndRegister'
      };
      // 使用手机号登录
      await signInByMobile(data).then(res => {
        console.log(res);
        instance?.proxy?.$Bus.emit("showLoginLoading", false);
        if (res.success) {
          localStorage.setItem('token', res.result.token);
          localStorage.setItem('refreshToken', res.result.refreshToken);
          localStorage.setItem('userId', res.result.userId);
          localStorage.setItem('userType', res.result.userType);
          localStorage.setItem('wdpId', res.result.wdpId);
          router.push('/play');
        } else {
          instance?.proxy?.$Bus.emit("showToast", true);
          setTimeout(() => {
            instance?.proxy?.$Bus.emit("showToast", false);
          }, 2000);
        }
      }).catch(() => {
        instance?.proxy?.$Bus.emit("showLoginLoading", false);
        instance?.proxy?.$Bus.emit("showToast", true);
        setTimeout(() => {
          instance?.proxy?.$Bus.emit("showToast", false);
        }, 2000);
        // router.push('/')
      });
    };
    // 微信登录
    const loginByWeChat = async () => {
      let url = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxbf013ed3e2b4e4f3&redirect_uri=" + encodeURIComponent('https://szls.szmuseum.com/play') + "&response_type=code&scope=snsapi_base&state=123#wechat_redirect";
      window.open(url);
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(_ctx.isPc ? 'login' : 'login login-m')
      }, [_hoisted_1, _createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_input, {
        modelValue: mobile.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => mobile.value = $event),
        placeholder: "请输入手机号码",
        class: "from-input"
      }, {
        prefix: _withCtx(() => [_hoisted_5]),
        _: 1
      }, 8, ["modelValue"]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_input, {
        modelValue: code.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => code.value = $event),
        placeholder: "请输入验证码",
        class: "from-input"
      }, {
        prefix: _withCtx(() => [_hoisted_7]),
        default: _withCtx(() => [_createTextVNode("` ")]),
        _: 1
      }, 8, ["modelValue"]), _createElementVNode("div", {
        class: _normalizeClass(codeDisable.value ? 'send-code' : 'send-code code-disable'),
        onClick: getCode
      }, _toDisplayString(timeNum.value == 60 ? '获取验证码' : timeNum.value + 's'), 3)])]), _createElementVNode("div", {
        class: _normalizeClass(loginDisable.value ? 'login-but' : 'login-but login-disable'),
        onClick: goInit
      }, "登录", 2), _withDirectives(_createElementVNode("div", _hoisted_8, _hoisted_12, 512), [[_vShow, !_ctx.isPc]]), _withDirectives(_createElementVNode("img", {
        class: "wechat-img",
        src: _imports_3,
        onClick: loginByWeChat
      }, null, 512), [[_vShow, !_ctx.isPc]])])], 2);
    };
  }
});